import React, { useState, useEffect } from 'react';
import { Chart } from 'primereact/chart';

function DoughnutChart({ labels, data, centerText }) {
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement);
        const records = {
            labels: labels,
            datasets: [
                {
                    data: data,
                    backgroundColor: [
                        documentStyle.getPropertyValue('--red-500'),
                        documentStyle.getPropertyValue('--gray-500'),
                    ],
                    hoverBackgroundColor: [
                        documentStyle.getPropertyValue('--red-500'),
                        documentStyle.getPropertyValue('--gray-500'),
                    ]
                }
            ]
        };
        const options = {
            cutout: '70%',
            plugins: {
                legend: {
                    display: false,
                },
            },
        };

        setChartData(records);
        setChartOptions(options);
    }, [data]);

    return (
        <div className="chart-container">
            <Chart type="doughnut" data={chartData} options={chartOptions}/>
            <div className="doughnut-label">{centerText}</div>
        </div>
    );
}

export default DoughnutChart;
